import React from 'react'
import { Alert, Button, Card, Form, Input, Layout, Typography } from 'antd'
import { useNavigate, useLocation } from 'react-router-dom'
import { login } from '../../auth/api'
import { setAccessToken } from '../../auth/storage'

const { Title } = Typography
const { Content } = Layout

export default function LoginPage() {
  const [form] = Form.useForm()
  const [error, setError] = React.useState<string | null>(null)
  const [loading, setLoading] = React.useState(false)

  const navigate = useNavigate()
  const location = useLocation()

  const from = (location.state as any)?.from?.pathname || '/'

  const onFinish = async (values: any) => {
    setError(null)
    setLoading(true)
    try {
      const res = await login(values.username, values.password)
      if (!res.ok) {
        setError(res.error)
        return
      }

      setAccessToken(res.data.token)
      navigate(from, { replace: true })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Layout style={{ minHeight: '100vh', justifyContent: 'center', alignItems: 'center', background: '#f0f2f5' }}>
      <Content style={{ maxWidth: 400, width: '100%', padding: 16 }}>
        <Card>
          <div style={{ textAlign: 'center', marginBottom: 24 }}>
            <Title level={3}>Admin Portal</Title>
          </div>
          
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            requiredMark={false}
          >
            {error ? <Alert type="error" showIcon message={error} style={{ marginBottom: 12 }} /> : null}

            <Form.Item
              label="Username"
              name="username"
              rules={[{ required: true, message: 'Please enter your username' }]}
            >
              <Input autoFocus />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[{ required: true, message: 'Please enter your password' }]}
            >
              <Input.Password />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" block loading={loading}>
                Sign in
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Content>
    </Layout>
  )
}
